// XS adequate-premium selection, mirroring the XS Rating tab.

export const GL_ADEQUATE_SUBLINES = ["premOps", "pco", "liquor"];

// Split the GL-total market charged across sublines by exposure-rated share (Excel C2).
export const allocateGlMarketCharged = (
  exposureRated,
  marketChargedGlTotal
) => {
  const totalErp = GL_ADEQUATE_SUBLINES.reduce(
    (sum, key) => sum + (exposureRated?.[key] ?? 0),
    0
  );
  return GL_ADEQUATE_SUBLINES.reduce((acc, key) => {
    acc[key] =
      marketChargedGlTotal != null && totalErp > 0
        ? marketChargedGlTotal * ((exposureRated?.[key] ?? 0) / totalErp)
        : null;
    return acc;
  }, {});
};

// Override wins, else the higher of exposure-rated vs market-charged (Excel D2 = MAX(C2,B2)).
export const selectedAdequate = (exposureRated, marketCharged, override) =>
  override ?? Math.max(exposureRated ?? 0, marketCharged ?? 0);

// Auto 1x1 primary premium (auto FSES/ISO band-1 base): the higher of the
// exposure-rating premium (at selected rates) or the market-charged 1x1 premium
// the engine restates to $1M — Excel MAX(K15, K14).
export const autoPrimaryPremium = (exposureRatingSelected, marketCharged1x1) =>
  exposureRatingSelected == null && marketCharged1x1 == null
    ? null
    : Math.max(exposureRatingSelected ?? 0, marketCharged1x1 ?? 0);
